import './stylus/main.styl'
import './assets/fonts/proxima-nova/fonts.styl'
import Vue from 'vue'
// import { VuePlugin } from 'vuera'
import './plugins/axios'
import './plugins/vuetify'
import router from './router'
import store from './store'
import VueTippy from 'vue-tippy'
// import VueAnime from 'vue-animejs';
import App from './App.vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import i18n from './plugins/i18n'
import vueHeadful from 'vue-headful'
import PageTitle from './components/utils/PageTitle.vue'
import VeeValidate from 'vee-validate'
import ResizeSensor from './directives/resize-sensor-dir'
import SelectScrollEnd from './directives/select-scroll-end'
import routerMixins from './mixins/router'
import constants from './constants'

// import anime from 'animejs';
const anime = require('animejs').default
console.log(anime)

const VueAnime = {
  install (Vue, options) {
    Vue.prototype.$anime = anime;
  }
}

Vue.config.productionTip = false
// Vue.use(VuePlugin)
Vue.use(VeeValidate)
Vue.use(VueTippy, {
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: true
      }
    }
  }
})
Vue.use(VueAnime)
Vue.component('vue-headful', vueHeadful)
Vue.component('page-title', PageTitle)
Vue.directive('resize-sensor', ResizeSensor)
Vue.directive('select-scroll-end', SelectScrollEnd)
const AppMixin = {
  data: function() {
    return {
      get APP_NAME() {
        return process.env.VUE_APP_NAME
      },
      colors: constants.colors,
      roles: constants.roles
    }
  }
}
Vue.mixin(AppMixin)
Vue.mixin(routerMixins)
console.log(routerMixins)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
